export default (theme) => ({
    root: {
        minHeight: 200,
        position: 'relative',
    },
    rootFill: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
        minHeight: 0,
    },
    error: {
        color: theme.colors.textLight.primary,
        display: 'block',
        padding: '16px 0',
    },
    iframe: {
        background: theme.colors.transparent,
        border: 0,
        display: 'block',
        width: '100%',
    },
    iframeFill: {
        flex: 1,
        minHeight: 0,
    },
    loader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        minHeight: 200,
    },
});
